// extracted by mini-css-extract-plugin
export default {"bottom-text-container":"BottomText_bottom-text-container__95PY7","empty-box":"BottomText_empty-box__F3y78","empty-img":"BottomText_empty-img__I09Xz"};